import { useGlobalSettings } from '../../hooks/useGlobalSettings';
import { useAvatar } from '../../hooks/useAvatar';
import { useScreensaverData } from '../../hooks/pages/useScreensaverData';
import Animation from '../common/Animation';
import AnimatedWordsMarkdown from '../common/AnimatedWordsMarkdown';

export default function Screensaver({ station, theme }) {
  const { data: pageData, error: pageDataError } = useScreensaverData(station);
  const { globalSettings, error: globalSettingsError } = useGlobalSettings();
  const { avatarData, error: avatarDataError } = useAvatar('Bildschirmschoner');

  if (globalSettingsError || pageDataError || avatarDataError) {
    return <div>Fehler: {globalSettingsError || pageDataError || avatarDataError}</div>;
  }

  if (!globalSettings || !pageData || !avatarData) {
    return <div>Laden...</div>;
  }

  // API response data
  const { text } = pageData;
  const { logoUrl } = globalSettings;
  const avatar = avatarData[0]?.animation;

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      {/* Landscape-Layout */}
      <div className="flex h-screen">
        <div className="flex-1 md:w-1/3 flex flex-col items-start justify-start relative">
          {/* Logo */}
          <img src={logoUrl} alt="Logo" className="absolute top-12 left-12 h-14" />

          {/* Avatar */}
          <div className="absolute bottom-0 transform -translate-x-64">
            <Animation src={avatar} className={'object-contain portrait:h-full portrait:w-auto landscape:min-w-fit'} />
          </div>
        </div>

        {/* Textbox */}
        <div
          className="flex flex-2 flex-col justify-center md:w-1/2 rounded-br-[150px] rounded-tl-[150px] px-12 py-20 mr-48 ml-8 my-28"
          style={{ backgroundColor: theme.screensaverForegroundColor }}
        >
          <AnimatedWordsMarkdown text={text} className={'text-5xl'} />
        </div>
      </div>
    </div>
  );
}